/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('common.header');

var $ = window.jQuery = require('base');

var lazyload = $.Deferred(), context = $.Deferred(), bootstrap = $.Deferred(), behavior_tracer = $.Deferred();

require.ensure('block.lazyload', function(){lazyload.resolve(require('block.lazyload'));})
require.ensure('context', function(){require('context').done(function(ctx, user){context.resolve(ctx)})})
require.ensure('behavior.tracer', function(){behavior_tracer.resolve(require('behavior.tracer'))})
context.done(function(context){})
//context.init_header_link();
lazyload.done(function(lazyload){
	require.ensure(['../bootstrap/collapse', '../bootstrap/transition'], function () {
		require('../bootstrap/collapse');
		require('../bootstrap/transition');
		$('#cat_con').on('shown.bs.collapse', function () {
			lazyload.call($(this), function () {
				require.ensure('superslide', function () {
					require('superslide');
					lazyload.call($('#cat_nav').find('[data-lazy-path]'), function () {
						$("#cat_nav .cat_content").slide({
							type : "menu",
							titCell : ".mod_cate",
							targetCell : ".mod_subcate",
							delayTime : 0,
							triggerTime : 10,
							defaultPlay : false,
							returnDefault : true
						});
					})
				})
			})
		})
		bootstrap.resolve();
	});
}).done(function(lazyload){
	$('#mini_cart').length && lazyload.call($('#mini_cart'), update_mini_cart);
	// 右边导航
	$('#sideBar').length && require.ensure('../vendor/com.jufeng.sidebar', function () {
		$('#sideBar')[0].done(function(){
			require('../vendor/com.jufeng.sidebar');
		})
	})
})

function update_mini_cart(){
	require.ensure('../bootstrap/dropdown', function(){
		require('../bootstrap/dropdown');
	})
	var mini_cart = $(this);
	// 如果点击删除则删除
	$(this).on('click', '[data-cartid]', function(){
		var $this = $(this), cart_id = $this.data('cartid');
		require.ensure('../cart/com.jufeng.cart', function(){
			var cart = require('../cart/com.jufeng.cart');
			cart.delete_cart(cart_id, function(){
				$this.closest('a.item').remove();
				var el_size = mini_cart.find('#mini_cart_size');
				el_size.html(mini_cart.find('a.item').length);
			})
		})
	})
}

require.ensure('search', function () {
	require('search');
});

// 优惠券激活
require.ensure('../member/com.jufeng.member.coupon.active.js', function () {
	require('../member/com.jufeng.member.coupon.active.js')
});


module.exports = {
	context : context,
	lazyload : lazyload,
	bootstrap : bootstrap,
	update_mini_cart : update_mini_cart,
	behavior_tracer : behavior_tracer
}

require('../css/voucher.less');



// WEBPACK FOOTER //
// ./src/main/javascript/common/com.jufeng.common.header.js